import classNames from 'classnames';
import React, { memo } from 'react';
import { Views } from 'src/components/Views';

import { Button, Space } from '@sravni/react-design-system';

import { useDictionaries } from '../../../hooks/news';
import { Card } from '../Card';
import { IListsCardProps } from '../types';
import { getTestButtonText } from '../utils/getTestButtonText';

import styles from './styles.module.scss';

export const TestsCard = memo<IListsCardProps>(({ material, index, useLazyLoad = true, direction = 'vertical' }) => {
  const { alias, rubric, picture, miniPicture, publishDate, pubDate, title, tags, visits } = material;

  const { rubrics } = useDictionaries();

  const currentRubric = rubrics?.find((el) => el.value === rubric);

  const buttonText = getTestButtonText(tags);
  return (
    <Card direction={direction}>
      {(picture || miniPicture) && (
        <Card.Image
          alt={title}
          //@ts-ignore
          src={picture?.url || miniPicture}
          lazy={useLazyLoad}
          width={picture?.width}
          height={picture?.height}
          shieldText={material.advertisingShieldText}
          className={classNames(styles.image)}
        />
      )}
      <Card.Content>
        <Card.Row>
          {currentRubric && <Card.Rubric rubric={currentRubric} className={styles.text} />}
          <Space size={12}>{tags.includes('Партнёрский материал') && <Card.Tag>Партнерский материал</Card.Tag>}</Space>
        </Card.Row>

        <Card.Row className={styles.titleRow}>
          <Card.Title id={alias} as={index === 0 ? 'h1' : 'h2'} className={styles.text}>
            {title}
          </Card.Title>
        </Card.Row>
        <Card.Row justify="space-between" align="center">
          {buttonText && (
            <Button size={36} className={classNames(styles.button, styles.text)}>
              {buttonText}
            </Button>
          )}
          <Space size={8} className={buttonText && styles.info} justify={!buttonText ? 'space-between' : 'start'}>
            <Card.Date className={styles.text}>{publishDate || pubDate}</Card.Date>
            <Views className={styles.views} size={12}>
              {visits}
            </Views>
          </Space>
        </Card.Row>
      </Card.Content>
    </Card>
  );
});
